import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getHighRiskSupplementCategories } from '@api/highRiskSupplements';

export const handleGetRiskSupplementCategories = createAsyncThunk<AxiosResponse<any>, void>(
  'getHighRiskSupplementCategories',
  getHighRiskSupplementCategories,
);
